<template>
  <v-app>
    <transition name="slide-x-transition" mode="out-in">
      <MainMenu :darkMode="darkMode" v-if="loggedIn"></MainMenu>
    </transition>
    <v-main :class="darkMode ? '' : 'la-creme'">

      <v-container fluid>
        <transition name="scale-transition" mode="out-in">
          <v-card  class="ma-5" v-if="$store.state.devMode">
            <v-alert dark class="secretComponent">
              <div class="pa-2 ">
                <div class="text-center">
                  <span class="green--text font-weight-bold">You Found Development Mode!</span>
                  <div>
                    <v-icon x-large color="green">mdi-vuejs</v-icon>
                  </div>

                </div>

                <pre ><code class="green--text grey darken-4">{{$store.state}}</code></pre>
              </div>
            </v-alert>
          </v-card>
        </transition>

        <template>
          <v-breadcrumbs v-if="loggedIn && items"
            class="text-uppercase grey--text pb-0"
            divider=">"
            :items="items"
          >
          </v-breadcrumbs>
          <div class="px-2 px-sm-5">
            <transition name="fade-transition" mode="out-in">
              <router-view :darkMode="darkMode"></router-view>
            </transition>

          </div>
        </template>
        <v-snackbar
          dark
          top
          right
          :color="snackbar.color"
          v-model="snackbarActive"
          :timeout="2000"
        >
          {{ snackbar.text }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              aria-label="Close Notification"
              v-bind="attrs"
              @click="snackbar = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>

        </v-snackbar>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import MainMenu from "./components/MainMenu";
  import { isPWA } from "./utils";
  import { version } from "../package.json";
  import { mapGetters, mapActions } from "vuex";


  export default {
    name: 'PropertyManager',
    props: {
      source: String,
    },
    components: {
      MainMenu
    },
    data: () => ({
      snackbarActive: false,
      items: [],
    }),
    created() {
      document.title = this.$route.meta.title || 'Property Manager';
      this.setBreadCrumbs();
      this.analyticsEvent();
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.$vuetify.theme.dark = true;
      }
    },
    watch: {
      '$route' (to) {
        document.title = to.meta.title || 'Property Manager';
        this.analyticsEvent();
      },
      '$route.path': function (value) {
        if (!value.includes('/properties') && this.propertyID){
          this.clearProperty();
        }
      },
      'darkMode': function (value) {
        this.$vuetify.theme.dark = value
      },
      // 'devMode': function (value) {
      //   this.$vuetify.theme.dark = value;
      // },
      '$route.name': function () {
        this.setBreadCrumbs();
      },
      'snackbar': function () {
        this.setSnackbar();
      }
    },
    computed: {
      darkMode(){
       return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
      },
      ...mapGetters([
        'accountID',
        'signingIn',
        'loggedIn',
        'devMode',
        'propertyID',
        'snackbar',
        'unknownUser'
      ]),

    },
    methods:{
      analyticsEvent(){
        this.$analytics.setCurrentScreen(this.$route.meta.title);
        this.$analytics.logEvent("page_view");
        this.$analytics.logEvent("screen_view", {
          app_name: isPWA() ? "pwa" : "web",
          screen_name: this.$route.meta.title,
          app_version: version
        });
      },
      setSnackbar(){
        this.snackbarActive = true;
      },
      setBreadCrumbs(){
        this.items = [{
          disabled: false,
          exact: true,
          to: '/',
          link: true,
          text: 'Home',
        }];
        if (this.$route.matched.length > 1){
          this.$route.matched.forEach((routeItem, index) => {
            let disabled = (index === (this.$route.matched.length - 1));
            this.items.push({
              disabled,
              exact: true,
              to: routeItem.path,
              link: true,
              text: routeItem.name,
            });
          });
        } else if (this.$route.name !== 'Dashboard'){
          this.items.push({
            disabled: true,
            exact: true,
            to: 'properties',
            link: true,
            text: this.$route.name,
          });
        }
      },
      ...mapActions([
        'setProperties',
        'clearProperty',
      ]),

    }
  }
</script>

<style lang="scss">
  $la-creme: #f3f3f4;
  .la-creme{
    background-color: $la-creme !important;
    &--text{
      background-color: $la-creme;
    }
  }
  .secretComponent{
    overflow-y:scroll;
    height:300px;
  }
  .logo-icon{
    font-size:4.5rem !important;
  }
  .logo-text{
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1.9rem;
  }
</style>